import type { PageReadPayload } from './types'
import { PageReadKey } from './types'

export function usePageReadPayload(
  searchParams: URLSearchParams,
  defaultSize = 10
): PageReadPayload {
  const maybeOffset = searchParams.get(PageReadKey.Offset)
  const maybeLimit = searchParams.get(PageReadKey.Limit)

  const size = maybeLimit ? Number(maybeLimit) : defaultSize
  const offset = maybeOffset ? Number(maybeOffset) : 0
  const page = Math.floor(offset / size) + 1

  return {
    page,
    size,
    sort: searchParams.get(PageReadKey.Sort),
    q: searchParams.get(PageReadKey.Search)
  }
}
